var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-cabinet-referral-info-list-table"},[_c('ui-table',_vm._b({attrs:{"theme":"secondary"}},'ui-table',_vm.tableData,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }